import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Nullable } from "service";

export const useGetParamOrRedirect = <T>(
  params: string[],
  redirectTo: string,
): Nullable<T> => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [p, setP] = useState<Nullable<T>>(null);

  useEffect(() => {
    let mustRedirect = false;
    // eslint-disable-next-line
    const paras: any = {};
    for (const key of params) {
      const paramValue = searchParams.get(key);
      if (!paramValue) {
        mustRedirect = true;
        break;
      }
      paras[key] = paramValue;
    }

    if (mustRedirect) {
      navigate(redirectTo);
      return;
    }

    setP(paras);
  }, []);

  return p as Nullable<T>;
};
